import React from "react";
import { DropdownSelect } from "components/InputStyled";
import { useProfile } from "context/ProfileContext";

export default function OrganizationSelector({ onSelectOrganization }) {
  const { availableOrgs, selectedOrg, orgMode, selectOrg } = useProfile();

  if (orgMode !== "multi" || availableOrgs.length <= 1) return null;

  const handleChange = (id) => {
    const organization =
      availableOrgs.find((org) => String(org.id) === String(id)) || null;
    (onSelectOrganization || selectOrg)(organization);
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-medium text-muted">Org</span>
      <DropdownSelect
        ariaLabel="Organization"
        value={selectedOrg?.id || ""}
        onChange={handleChange}
        options={availableOrgs.map((org) => ({
          value: org.id,
          label: org.name,
        }))}
        placeholder="Select organization"
        className="min-w-56"
      />
    </div>
  );
}
